'use client';

import type { PropsWithChildren } from 'react';
import React from 'react';
import cx from 'clsx';

import type { StyleableProps } from '~/types';

type Props = {
  opened?: boolean;
  onClick?: () => void;
} & PropsWithChildren &
  StyleableProps;

export function Overlay({ opened, onClick, className, children }: Props) {
  const childrenRef = React.useRef<HTMLDivElement>(null);

  if (!opened) {
    return null;
  }

  return (
    <div
      role="presentation"
      className={cx(
        'pointer-events-auto fixed inset-0 z-[25] flex items-center justify-center bg-[rgb(0_0_0_/_40%)]',
        className,
      )}
      onClick={onClick}
    >
      <div ref={childrenRef}>{children}</div>
    </div>
  );
}
